import React from 'react';
import { FaMoon, FaSun, FaDesktop } from 'react-icons/fa';
import { useAppTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.scss';

export const ThemeToggle = ({ 
  variant = 'default', 
  size = 'medium',
  showSystemOption = false,
  className = '',
  ...props 
}) => {
  const { isDarkMode, isSystemTheme, toggleTheme, setTheme, useSystemTheme } = useAppTheme();

  const handleToggle = () => {
    if (showSystemOption && isSystemTheme) {
      // If currently using system theme, switch to manual toggle
      toggleTheme();
    } else {
      toggleTheme();
    }
  };

  const getIcon = () => {
    if (isSystemTheme) {
      return <FaDesktop />;
    }
    return isDarkMode ? <FaSun /> : <FaMoon />;
  };

  const getTitle = () => {
    if (isSystemTheme) {
      return "Using system theme - Click to switch to manual mode";
    }
    return isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode";
  };

  const getAriaLabel = () => {
    if (isSystemTheme) {
      return "Using system theme - Click to switch to manual mode";
    }
    return isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode";
  };

  return (
    <div className={`theme-toggle-container ${className}`}>
      <button
        className={`theme-toggle-btn theme-toggle-btn--${variant} theme-toggle-btn--${size}`}
        onClick={handleToggle}
        title={getTitle()}
        aria-label={getAriaLabel()}
        {...props}
      >
        {getIcon()}
      </button>
      
      {showSystemOption && (
        <div className="theme-toggle-menu">
          <button
            className={`theme-toggle-option ${!isSystemTheme && !isDarkMode ? 'active' : ''}`}
            onClick={() => setTheme('light')}
            aria-label="Use Light Theme"
          >
            <FaSun />
            <span>Light</span>
          </button>
          <button
            className={`theme-toggle-option ${!isSystemTheme && isDarkMode ? 'active' : ''}`}
            onClick={() => setTheme('dark')}
            aria-label="Use Dark Theme"
          >
            <FaMoon />
            <span>Dark</span>
          </button>
          <button
            className={`theme-toggle-option ${isSystemTheme ? 'active' : ''}`}
            onClick={useSystemTheme}
            aria-label="Use System Theme"
          >
            <FaDesktop />
            <span>System</span>
          </button>
        </div>
      )}
    </div>
  );
};
